import { LocationSortOption, LocationStore } from '../location-store';
import React from 'react';
import type { LocationStoreView } from '../types/locations';

export interface LocationListProps {
    store: LocationStore;
    onClickRow?: (id: number) => void;
    moveFocusNext?: () => void;
    inputRef?: React.MutableRefObject<HTMLInputElement | null>;
}

export function useLocationList(props: LocationListProps) {
    const { store, onClickRow, moveFocusNext, inputRef } = props;
    const sortMode = store.sortMode;
    const { groupCounts, groupHeaders, list } = store.data;

    // Property access for mobx update. (required, Otherwise mobx doesn't update and state doesn't change)
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    groupCounts.length;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    groupHeaders.length;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    list.length;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    store.highlightedLocationIndex;

    function updateSort(option: LocationSortOption): void {
        if (sortMode?.option === option) {
            if (sortMode?.direction === 'ASC') {
                store.setSort({ option, direction: 'DSC' });
            } else {
                store.setSort(undefined);
            }
        } else {
            store.setSort({ option, direction: 'ASC' });
        }
    }

    const { esriCustomItems, mark43Items, esriItems, latLngItems, forcedResults } =
        store.renderedLocationData;

    function onRowSelected(row: LocationStoreView) {
        if (onClickRow) {
            onClickRow(row.id);
        }
        store.setSelectedLocation(row);
        inputRef?.current?.focus?.();
        moveFocusNext?.();
    }

    return {
        data: {
            mark43Items,
            esriItems,
            esriCustomItems,
            latLngItems,
            forcedResults,
        },
        operations: { onRowSelected, updateSort },
        state: { sortMode },
    };
}
